// extracted by mini-css-extract-plugin
export default {"loader":"LongestSessions_loader__G+EPD","content":"LongestSessions_content__IQ-EN"};